import React, { Component } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import './scss/style.scss'
import SmoothScroll from "smooth-scroll";
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 200,
  speedAsDuration: true,
});

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))


const keys=["tr","en"]
class App extends Component {
 
  componentDidMount(){
    var data = window.location.toString();
    var data2 = window.location.origin;
    var data3=data.replace(data2+"/","");
    var arr=data3.split("/");
    var eleman=-1
    for(var i=0;i<arr.length;++i){
      if(arr[i]=="#"){
        eleman=i+1;
        break;
      }
    }
   
    if(eleman!=-1 && keys.includes(arr[eleman])){
      localStorage.setItem("lang",arr[eleman])
    }else{
      localStorage.setItem("lang","tr")
    }
  }
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
            
            <Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    )
  }
}

export default App
